<template>
  <v-row>
    <v-col v-if="item">
      <p class="sub-header1 text-tcdc-green bold">{{ item[`branch_name_${lang}`] ? item[`branch_name_${lang}`]:'' }}</p>
<!--      <p class="vhtml" v-if="item[`detail_${lang}`]" v-html="item[`detail_${lang}`]"></p>-->
      <p class="sub-header2 text-tcdc-green bold">ติดต่อเรา</p>
      <p class="vhtml" v-if="item.contact" v-html="item.contact[`description_${lang}`]"></p>
      <p class="sub-header2 text-tcdc-green bold">เวลาทำการ</p>
      <p class="vhtml" v-if="item.location" v-html="item.location.opening_hours_detail"></p>
      <GreenButton
              v-if="item.location && item.location.lat && item.location.lon"
              label="ดูแผนที่"
              @onPress="openMap(item.location.lat, item.location.lon)"
      ></GreenButton>
      <Divider v-if="showDivider" />
    </v-col>
  </v-row>
</template>

<script>
import Divider from "../../components/dividers/Divider";
import GreenButton from "../buttons/GreenButton";
import { mapState } from 'vuex';

export default {
  props: {
    item: {
      required: true
    },
    showDivider: {
      type: Boolean,
      default: true
    }
  },
  components: {
    Divider,
    GreenButton
  },
  computed: {
    ...mapState({
      lang: state => state.Branch.lang
    })
  },
  methods: {
    openMap(lat, lon) {
      if (lat && lon) {
        window.open(`https://www.google.com/maps/search/?api=1&query=${lat},${lon}`)
      }
    }
  }
};
</script>

<style>
</style>
